import React from "react";
import { Div, Text } from "atomize";
import AnimateLink from "./AnimateLink";

const MobileMenuCollapseItems = ({ submenu, toggleMobileHeader }) => (
  <Div p={{ b: "2rem" }}>
    {submenu.map((item, index) => (
      <Div>
        {item &&
          item.menu.map((subitem, index) => (
            <AnimateLink to={subitem.link}>
              <Div p="0 0 1.5rem 0" onClick={() => toggleMobileHeader(false)}>
                <Text
                  textColor="gray700"
                  textSize={{ xs: "paragraph" }}
                  textWeight="700"
                >
                  {subitem.heading}
                </Text>
                <Text
                  textColor="gray700"
                  textSize={{ xs: "caption2", md: "subheader2" }}
                >
                  {subitem.paragraph}
                </Text>
              </Div>
            </AnimateLink>
          ))}
      </Div>
    ))}
  </Div>
);

export default MobileMenuCollapseItems;
